// extracted by mini-css-extract-plugin
export default {"sttContent":"STTSkeleton_sttContent__tV6Qs","usersInfoLine":"STTSkeleton_usersInfoLine__nNYHc"};